import React, { useEffect, useState } from 'react';
import GameLogic from './logic/gameLogic';
import { GameAudioManager } from './GameAudio';
import Home from './pages/Home';
import Story from './pages/Story';
import Cutscene from './common/Cutscene';
import { initialize as initializeAssets } from './logic/assetUtils';

window.gameLogic = new GameLogic();
window.gameAudio = new GameAudioManager();
window.gameAudio.load();


export default function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [assetsReady, setAssetsReady] = useState(false);

  useEffect(() => {
    initializeAssets().then(() => {
      console.log('Assets fully preloaded');
      setAssetsReady(true);
    });
  }, []);

  const handleStartGame = () => {
    window.gameLogic.reset();
    setCurrentPage('cutscene');
  };

  const handleLeaveStory = () => {
    setCurrentPage('home');
  };

  const handleCutsceneComplete = () => {
    setCurrentPage('story');
  };

  if (!assetsReady) {
    return (
      <div className="mx-auto relative overflow-hidden bg-gray-900">
        <div className="flex items-center justify-center h-full text-white">
          Loading...
        </div>
      </div>
    );
  }

  return (
    <div>
      {currentPage === 'cutscene' && (
        <Cutscene onComplete={handleCutsceneComplete} />
      )}
      {currentPage === 'home' && (
        <Home gameLogic={window.gameLogic} onStartGame={handleStartGame} />
      )}
      {currentPage === 'story' && (
        <Story gameLogic={window.gameLogic} onLeaveStory={handleLeaveStory} />
      )}
    </div>
  );
}
